import { ViewReadOnlyBudgetButton } from './ViewReadOnlyBudgetButton';
import { ProblemPropertyIndicator } from './ProblemPropertyIndicator';

export const ReadOnlyDrawPanel = ({ property, styles, validateSubmission, onProblemPropertyChange, budgetExists }) => {
    return (
        <>
            {budgetExists && (
                <div style={styles.displayFlex}>
                    <p>View Budget</p>
                    <ViewReadOnlyBudgetButton
                        property={property}
                        styles={styles}
                        validateSubmission={validateSubmission}
                    />
                    <ProblemPropertyIndicator
                        problemProperty={property.isProblemProperty}
                        onChange={onProblemPropertyChange}
                    />
                </div>
            )}
            {!budgetExists && (
                <div style={styles.displayFlex}>
                    <p>Loan was repaid without a budget added.</p>
                </div>
            )}
        </>
    );
};
